var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAriba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_2289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 0V49H42.5309L91.5 0.00582888H-7.5V0Z",
    fill: "url(#paint0_linear_6_2289)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.854 22.5246H33.7678V18.5196H34.8551C36.3065 18.5196 37.4614 19.0012 37.4614 20.4975C37.4614 22.0429 36.3059 22.5268 34.8551 22.5268M23.1546 25.3934C22.6153 25.3956 22.0798 25.3006 21.5734 25.1124L23.1389 20.1337H23.1714L24.7055 25.1266C24.2079 25.305 23.6837 25.3957 23.1557 25.395M34.5673 15.2629H29.6286V27.1024L25.3157 15.2629H21.0422L17.3585 25.1594C16.969 22.6681 14.4076 21.8035 12.3926 21.1576C11.0652 20.7212 9.6517 20.0939 9.66414 19.3929C9.67496 18.8201 10.4236 18.2877 11.8982 18.3674C12.8925 18.4181 13.7769 18.4983 15.5095 19.3476L17.2313 16.3354C15.6426 15.5171 13.4415 15.0033 11.6397 15H11.6223C9.52134 15 7.77086 15.6901 6.6852 16.822C5.93462 17.6004 5.51118 18.641 5.50325 19.7267C5.47512 21.252 6.03228 22.3342 7.19855 23.1999C8.18468 23.9293 9.44344 24.3978 10.5551 24.7502C11.9263 25.1746 13.0456 25.5488 13.0326 26.3447C13.0245 26.6349 12.9082 26.9109 12.7069 27.1182C12.3661 27.4728 11.8414 27.6092 11.1149 27.6266C9.71553 27.655 8.6791 27.4357 7.02545 26.4505L5.5 29.5021C7.20287 30.4774 9.12591 30.9929 11.0841 31H11.3421C13.0731 30.9673 14.4731 30.4681 15.5907 29.5621L15.7724 29.4039L15.284 30.7349H19.7656L20.5186 28.4253C22.2101 28.9773 24.0304 28.9849 25.7268 28.4471L26.4516 30.736H33.7667V25.9629H35.3636C39.2178 25.9629 41.5 23.9849 41.5 20.665C41.5 16.9692 39.2822 15.2738 34.5652 15.2738",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_2289",
    x1: 41.5029,
    y1: 0.15624,
    x2: 41.5029,
    y2: 49.6098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#06A5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#1870C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D61BC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_2289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 45,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAriba);
export default __webpack_public_path__ + "static/media/ariba.00bc26dd7aa6036ae7e7ddc8c744284c.svg";
export { ForwardRef as ReactComponent };